export const isClearMetalEmail = email =>
  Boolean(email && email.toLowerCase().endsWith('@clearmetal.com'))
